
import { Component, Vue, Prop } from 'nuxt-property-decorator'

@Component
export default class ThePaginator extends Vue {
  @Prop({ default: 1 }) totalPages!: number
  @Prop({ default: 1 }) currentPage!: number

  public changePage(event: any, page: number) {
    if (page === this.currentPage) {
      event.preventDefault()
      return
    }
    this.$emit('change-page', page)
  }
}
